<template>
    <div id="app" >

        <iframe id="download_host" style="display:none;"></iframe>

        <notifications animation-type="velocity" position="bottom right" :duration="5000" group="foo" />

        <section class="layout" v-if="state.is_user">
            <Navigation></Navigation>
            <div id="content">
                <router-view :key="$route.fullPath"/>
            </div>
            <Footer></Footer>
        </section>

        <template v-if="state.is_guest">
            <Login></Login>
        </template>

        <template v-if="state.need_token">
            <Login :need-token="true"></Login>
        </template>

    </div>
</template>

<script>

    import { tdj2 } from '@/tdj2.js'

    import Navigation from '@/components/Navigation'
    import Footer from '@/components/Footer'
    import Player from '@/components/Player'
    import Login from '@/components/Login'

    export default {
        components: { Navigation, Footer, Player, Login },
        data() {
            return {
                state: tdj2.state
            }
        },
        created() {

        },

        mounted() {

        }
    }
</script>
<style lang="less">

    html {
        width: 100%;
        height: 100%;
        /*overflow: hidden;*/
    }

    body {
        width: 100%;
        height: 100%;
        padding: 0px;
        margin: 0px;
    }

    body.modal-open {
        // to prevent strange issue with freezing safari when popping select
        font-family: "Trebuchet MS" !important;
    }

    div.modal-content {
        margin-bottom: 130px;
    }

    // Blue (.btn-primary) buttons that carry an explicit type="button" or
    // type="submit" attribute - e.g. b-modal's OK button, or the settings
    // panel's Save button - render with black text instead of Bootstrap's
    // intended white, until hovered. Root cause: Vuetify's own CSS reset
    // (imported via `vuetify/styles`) includes a rule targeting
    // `[type="button"], [type="submit"], [type="reset"], button { color:
    // inherit; }`. `.btn`'s own `color: var(--bs-btn-color)` and this
    // Vuetify attribute selector are tied in specificity (both a single
    // class/attribute selector), and Vuetify's rule is loaded later in the
    // bundle (main.js imports 'vuetify/styles' after bootstrap.css), so it
    // wins and the button inherits the page's near-black body text color.
    // `.btn:hover` has higher specificity (class + pseudo-class) and isn't
    // affected, which is why hovering suddenly shows the "correct" white -
    // that inconsistent flip is what looked broken. Plain hand-written
    // <button> elements without an explicit type attribute never match
    // Vuetify's selector, so they were never affected (e.g. the "сохранить"/
    // "скачать" buttons on the Tanda page stayed correctly white) - this was
    // already true back on Vue2/Vuetify2, just with the same collision.
    // Restoring Bootstrap's intended white text (rather than matching the
    // black at-rest color) directly, in both states, sidesteps the
    // specificity collision entirely instead of trying to win it.
    .btn-primary[type] {
        color: #fff !important;
        &:hover {
            color: #fff !important;
        }
    }

    #app {
        width: 100%;
        height: 100%;

        h2 {
            margin-bottom: 30px !important;
        }

        .layout {
            font-family: "Trebuchet MS";
            min-height: 100vh;
            /*overflow: hidden;*/
            display: block;
            position: relative;
            padding-bottom: 240px;

            a {
               color: #5c6bc0;
            }

            #content {
                margin-top: 30px
            }

        }
    }

    .lp-inline-form {
        // Bootstrap 5 dropped the `.form-group` class entirely (it no longer
        // appears anywhere in bootstrap.css) and no longer gives plain
        // <label> elements a default margin-bottom (that's now opt-in via
        // `.form-label`, which this app's templates don't use). Bootstrap 4
        // supplied both: `.form-group { margin-bottom: 1rem; }` and a global
        // `label { margin-bottom: .5rem; }`. Without them, every
        // `.form-group.row` in the settings panel (and the DJSet/Playlist
        // edit dialogs, which share this markup pattern) collapses flush
        // against its neighbor, since `.row` itself never had its own
        // margin-bottom (only `.form-group` did) and is explicitly zeroed
        // out below. Restoring both rules here brings back the original
        // spacing.
        .form-group {
            margin-bottom: 1rem;
        }
        label {
            margin-bottom: 0.5rem;
        }
        .form-control {
            display: inline-block !important;
        }
        // Templates put a Bootstrap column class directly on the same
        // element as `.form-control` (e.g. <b-form-input class="col-sm-2">,
        // which bootstrap-vue-next renders as <input class="form-control
        // col-sm-2">). In bootstrap.css, `.form-control { width: 100%; }`
        // (forms) is declared AFTER `.col-sm-2 { width: 16.666%; }` (grid)
        // in source order - confirmed by grepping the compiled CSS - and
        // since both are plain single-class selectors of equal specificity,
        // the later one (form-control) wins the cascade. That stretches
        // every input/select to the full row width and pushes it onto its
        // own line below the label, instead of sitting beside it at the
        // intended column width. Re-declaring the same widths here with
        // two-class selectors (higher specificity than either bootstrap
        // rule) restores the intended column sizing without touching
        // bootstrap.css or Bootstrap's cascade order.
        .form-control.col-sm-2 {
            width: 16.6666667%;
        }
        .form-control.col-sm-4 {
            width: 33.3333333%;
        }
        .form-control.col-sm-6 {
            width: 50%;
        }
        .form-text {
            display: inline-block !important;
        }
        // On production (Vue2), every `col-sm-*` cell in these forms got a
        // uniform 12px padding on all four sides - but that padding never
        // came from Bootstrap. It came from Vuetify 2's own grid CSS, which
        // (like Bootstrap 4) also defined plain `.col-sm-6`/`.col-sm-2`/etc.
        // classes, landing later in the stylesheet than Bootstrap's own
        // grid rule and so overriding its horizontal-only 15px gutter with
        // `padding: 12px` on all sides - confirmed by inspecting production's
        // matched CSS rules live. Vuetify 3 renamed all of its grid classes
        // to `.v-col-sm-*` specifically to stop colliding with Bootstrap
        // (confirmed in node_modules/vuetify/lib/components/VGrid/VGrid.css),
        // so this app's plain `col-sm-*` markup no longer matches anything
        // in Vuetify at all - only Bootstrap 5's `.row > *` rule applies now,
        // which supplies just the horizontal gutter (padding-left/right:
        // calc(var(--bs-gutter-x)*.5), 12px) and no vertical padding. Adding
        // it back here reproduces the old (accidental) box model without
        // reintroducing a dependency on Vuetify's grid.
        .row > [class*="col-sm-"]:not(.form-control) {
            padding: 12px;
        }
        // Giving labels/help-text 12px all around (above) makes them taller
        // than a `.form-control` sitting in the same `.row` - and `.row`
        // is `display: flex` with the default `align-items: stretch`.
        // Bootstrap 4's `.form-control` had an explicit `height: calc(1.5em
        // + 0.75rem + 2px)`, which is immune to flex-stretch (stretch only
        // applies when the cross-size is auto); Bootstrap 5 dropped that
        // explicit height and sizes `.form-control` purely from its own
        // padding + line-height + border, so as soon as a taller sibling
        // (like the label above) is in the same row, flex-stretch pulls the
        // input/select up to match it - it visually reads as "abnormally
        // large padding" even though the input's own padding didn't change.
        // Keeping `.form-control` out of the rule above (so it keeps
        // Bootstrap's own compact 0.375rem/0.75rem padding) and giving it
        // `align-self: center` here - instead of trying to stretch to fill
        // - lets it size to its own natural height and sit centered
        // alongside the taller label/help-text.
        .row > [class*="col-sm-"].form-control {
            align-self: center;
        }
        .row {
            margin-bottom: 0px;
        }
        .lp-checkbox {
            width: 15px;
            height: 32px;
            display: table-cell;
            margin-top: 0px;
            margin-bottom: -10px;
        }
    }

    ul.lp-large {
        font-size: 13pt;
        margin-left: 20px;
        a {
            font-weight: bold;
        }
    }

    #recording_listing {
        padding-left: 3%;
        padding-right: 3%;
    }

    .container-fluid {
        padding-left: 3% !important;
        padding-right: 3% !important;
    }

    nav.navbar {
        padding-left: 0px;
        padding-right: 0px;
    }

    // common

    .container-fluid h2 {
        margin-bottom: 30px !important;
        .octicon {
            margin-top: 10px;
        }
    }

    .lp-tips {
        padding: 15px 40px;
        margin-bottom: 20px;
        border: 1px solid #e8ebff;
        background-color: #f1f3ff;
        font-size: 10pt;
        .octicon {
            margin-top: 0px;
            color: #7885cd;
            position: absolute;
            margin-left: -25px;
        }
        ul {
            margin: 0px;
            padding: 0px;
            margin-left: 25px;
        }

    }

    .lp-alert {
        padding: 10px;
        margin-bottom: 20px;
        border: 1px solid #eecccc;
        background-color: #ffdddd;
        .octicon {
            color: red;
        }
    }

    .lp-info {
        padding: 10px;
        margin-bottom: 20px;
        border: 1px solid #eeeeee;
        background-color: #f5f5f5;
        color: #888888;
        .octicon {
            margin-right: 4px;
        }
    }


    a.red {
        color: red !important;;
    }
    a.red:hover {
        color: red !important;
    }

    .clickable {
        cursor: pointer;
    }

    .lp-float-right {
        float: right;
    }

    .octicon {
        display: inline-block;
        vertical-align: text-top;
        fill: currentColor;
    }

    .octicon {
        margin-top: 2px;
    }


    // tracklist-related

    .badge {
        margin-left: 5px;
        display: inline-block;
        margin-top: 1px;
        padding-top: 3px;
        vertical-align: top;
        font-size: 8pt;
    }

    .badge.badge-lp-entropy {
        background-color: #e2e1f4;
        /*background-color: white;*/
        color: black;
    }

    .badge.badge-lp-modern {
        background-color: rgb(255, 220, 208);
        color: black;
    }

    .badge.badge-lp-tangotunes {
        background-color: rgb(255, 207, 70);
        color: black;
    }

    // tanda list

    .tandas {

        .tanda td {
            font-size: 10pt;
            background-color: #ffd6d6;
            border-top: 1px solid #d6b4b4;

            a {
                color: black !important;
            }

            &.tags {
                padding-top: 0px;
                padding-bottom: 0px;
            }

            .tandatag {
                font-size: 9.5pt;
                padding: 1px 6px;
                margin-right: 7px;
                .octicon {
                    width: 13px;
                    height: 13px;
                    margin-top: 2px;
                }
            }

          }

         .tanda.completed td {
            background-color: #f3f3f3;
            border-top: 1px solid #cccccc;
         }

         .tanda.approved td {
            background-color: #c4ffd0;
             border-top: 1px solid #a4d6af;
        }

         .tanda.colored td {
            background-color: transparent !important;
             border-top: 0px !important;
        }

    }



    .tandatag {
        border: 1px solid;
        font-size: 10pt;
        padding: 2px 6px;
        display: inline-block;
        border-radius: 5px 0px 0px 0px;
        margin-right: 5px;
        .octicon {
                margin-top: 1px;
        }
    }

    .tandatag.tandatag-completed {
        background-color: #eeeeee;
        border-color: #d5d5d5;
    }

    .tandatag.tandatag-approved {
        background-color: #62f691;
        border-color: #44c06a;
    }

    .tandatag.tandatag-radio {
        background-color: #ffd300;
        border-color: #b89600;
        color: #695300;
    }

    .tandatag.tandatag-custom {
        background-color: #eeeeee;
        border-color: #d5d5d5;
    }

    .tandatag.off {
        opacity: 0.4;
    }

</style>
